import React, { useContext } from 'react';
import { ActualIconProps } from 'mobx/commonTypes';
import { useTheme } from '@mui/material/styles';
import { UiContext } from 'uiContext';
import { defaultSpacingPresets } from 'hooks/useGetSpacing';

export default function IconDownpour({
  style,
  extColor,
  isAutoscallable = true,
  sizeKey = '32x32',
}: ActualIconProps) {
  const theme = useTheme();
  const fill = extColor || theme.palette.customBackgrounds.contrast;
  const {
    spacings: {
      icons: { [sizeKey]: size },
    },
  } = useContext(UiContext);

  const w = isAutoscallable ? size.w : defaultSpacingPresets.icons[sizeKey].w;
  const h = isAutoscallable ? size.h : defaultSpacingPresets.icons[sizeKey].h;

  return (
    <svg
      style={style}
      width={w}
      height={h}
      viewBox="0 0 32 32"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.4753 9.24102C22.4233 9.24102 22.3734 9.24694 22.3221 9.24891C21.7453 6.81373 19.5633 5 16.9519 5C14.2076 5 11.9375 7.00247 11.5074 9.62376C11.1648 9.5284 10.8051 9.4725 10.4322 9.4725C8.53235 9.4725 6.94616 10.7989 6.5404 12.5758C5.05417 13.1585 4 14.602 4 16.2947C4 18.501 5.78874 20.2898 7.99573 20.2898H22.4753C25.5273 20.2898 28 17.8164 28 14.7657C28 11.715 25.5273 9.24036 22.4753 9.24036V9.24102Z"
        fill="white"
      />
      <path d="M8 27L10 22" stroke="white" strokeLinecap="round" />
      <path d="M12 27L14 22" stroke="white" strokeLinecap="round" />
      <path d="M16 27L18 22" stroke="white" strokeLinecap="round" />
      <path d="M20 27L22 22" stroke="white" strokeLinecap="round" />
    </svg>
  );
}
